<h2 mat-dialog-title>
  Ticket
</h2>

<mat-dialog-content>

  <div class="ticket-info">
    <p class="ticket-subject">{{ ticket.subject }}</p>
    <p class="ticket-message">{{ ticket.message }}</p>
  </div>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Admin Response</mat-label>

      <textarea
        matInput
        rows="3"
        formControlName="admin_response"
        placeholder="Enter response to the user"
      ></textarea>

      @if (form.controls.admin_response.hasError('required')) {
        <mat-error>Admin response is required</mat-error>
      }
    </mat-form-field>
  </form>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="closeDialog()">
    Close
  </button>

  <button
    mat-flat-button
    type="button"
    color="primary"
    (click)="resolveTicket()"
  >
    Resolve
  </button>
</mat-dialog-actions>